<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ itemProductId ? 'Update Item Products' : 'Create Item Products' }} </h3>
        </div>
        <div class="card-body">
          <item-products-form
            [itemProduct]="itemProduct"
          />
        </div>
      </div>
    </div>
    
  </div>
  